import axios from "axios";
const endpoint = "/users/v1/auth";

class AuthService {
	async signInWithEmailAndPassword(login) {
		const response = await axios.post(`${endpoint}/login`, login);
		const {
			data: { accessToken },
		} = response;
		this.setSession(accessToken);
		return accessToken;
	}

	setSession = (access_token) => {
		if (access_token) {
			sessionStorage.setItem("corksy_store_access_token", access_token);
			axios.defaults.headers.common.Authorization = `Bearer ${access_token}`;
		} else {
			sessionStorage.removeItem("corksy_store_access_token");
			delete axios.defaults.headers.common.Authorization;
		}
	};

	logout = () => {
		this.setSession(null);
	};
}

export default new AuthService();
